import React from "react";

const PreventiveAction = ({ prevention_actions }) => {
  // Utility to strip HTML tags
  const stripHtml = (html = "") => html.replace(/<[^>]+>/g, "");

  // Filter: only approved actions (you can add deleted/active filters if needed)
  const filteredActions = (prevention_actions || []).filter(
    (action) => action.imo_approval === 1
  );

  return (
    <div className="final-report-content mb-3">
      <h2 className="font-18 font-weight-bold heading-color mb-2">
        Preventive Actions:
      </h2>
      <ul className="text-color">
        {filteredActions.length > 0 ? (
          filteredActions.map((action, index) => (
            <li
              key={index}
               className="font-12 font-weight-light heading-color mb-2"
            >
              <strong>{action.action_title || <i>No title</i>}</strong>
              <br />
              <span className="text-muted">
                {action.action_description ? (
                  stripHtml(action.action_description)
                ) : (
                  <i>No description</i>
                )}
              </span>
            </li>
          ))
        ) : (
          <li className="font-13 font-weight-normal text-color mb-2">
            <i>No preventive actions approved.</i>
          </li>
        )}
      </ul>
    </div>
  );
};

export default PreventiveAction;
